import { Box, Modal, IconButton, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import CloseIcon from '@mui/icons-material/Close'

interface TrailerModalProps {
  open: boolean
  onClose: () => void
  title: string
  trailerUrl: string | null | undefined
}

const StyledModal = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  maxWidth: 900,
  backgroundColor: theme.palette.background.paper,
  borderRadius: Number(theme.shape.borderRadius) * 2,
  boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
  overflow: 'hidden',
}))

const StyledModalHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.divider}`,
}))

const StyledModalTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: 16,
  fontWeight: 600,
}))

const StyledVideoWrapper = styled(Box)({
  position: 'relative',
  paddingTop: '56.25%',
})

const StyledIframe = styled('iframe')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  border: 'none',
})

const getYouTubeEmbedUrl = (url: string) => {
  const match = url.match(/[?&]v=([^&]+)/)
  if (match) {
    return `https://www.youtube.com/embed/${match[1]}?autoplay=1`
  }
  return null
}

const TrailerModal = ({
  open,
  onClose,
  title,
  trailerUrl,
}: TrailerModalProps) => {
  return (
    <Modal open={open} onClose={onClose}>
      <StyledModal>
        <StyledModalHeader>
          <StyledModalTitle>{title} - Trailer</StyledModalTitle>
          <IconButton onClick={onClose} size='small'>
            <CloseIcon />
          </IconButton>
        </StyledModalHeader>
        <StyledVideoWrapper>
          {trailerUrl && open && (
            <StyledIframe
              src={getYouTubeEmbedUrl(trailerUrl) || ''}
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
              allowFullScreen
            />
          )}
        </StyledVideoWrapper>
      </StyledModal>
    </Modal>
  )
}

export default TrailerModal
